import React, { useState, useEffect } from 'react';
import TituloComponent from '../../components/Titulo/TituloComponent';
import { useLocation, useNavigate } from 'react-router-dom';
import { fazerCheckout } from '../../services/api';
import { atualizarDadosClienteLogado, getFinalCartaoUsuarioLogado } from '../../services/clienteService';
import { buscarProdutosEstabelecimentoParaCardapio, cadastrarPedido, comprarFichas } from '../../services/api';

import Carregando from '../../components/Carregando/Carregando';

import './CardapioPage.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../styles/global.css';

// cookies
import Cookies from 'js-cookie';

const CardapioPage = () => {

  const location = useLocation();
  const navigate = useNavigate();

  const [carregando, setCarregando] = useState(false);

  // dados do usuário, inclusive se for cliente logado
  const userData = JSON.parse(sessionStorage.getItem('userData')) || {};

  // vamos verificar o perfil do usuário
  const perfilUsuario = userData && userData.dadosPerfil ? userData.dadosPerfil.nome : null;

  // saber se o usuário deseja comprar fichas ou fazer pedido
  const [modo, setModo] = useState(location.state?.modo || 'pedido');

  const [produtosEstabelecimento, setProdutosEstabelecimento] = useState([]);
  const BASE_URL = JSON.parse(sessionStorage.getItem('BASE_URL'));
  const [pedidos, setPedidos] = useState([]); // array de pedidos
  const [observacoes, setObservacoes] = useState({}); // objeto para armazenar observações

  // controlar visibilidade das categorias de produtos
  const [categoriaAberta, setCategoriaAberta] = useState(null); // armazena a categoria visível
  const toggleCategoria = (nomeCategoria) => {
    setCategoriaAberta(prev => prev === nomeCategoria ? null : nomeCategoria);
  };

 
  // verificar se está logado e se é cliente
  const [informacoesUsuario, setInformacoesUsuario] = useState(
    {
      // aqui não tem dados de perfil - não está logado
      nome: '',
      email: '',
      numeroMesa: '',
      numeroComanda: '',
      numeroCpf: '',
      numeroTelefone: ''
    }
  );

  const dadosCheckin = 
    JSON.parse(Cookies.get('dadosCheckin'))
  ;
  
  useEffect(() => {
    if (location.state?.modo) {
      setModo(location.state.modo);
    }
  }, [location.state]);

  // buscar produtos do estabelecimento
  useEffect(() => {

    setCarregando(true);    

      console.log('--- ENTROU EM CARDAPIO PAGE ----');

      console.log('userData: ');
      console.log(userData.user);

      /**
       * vamos garantir que os dados das informações do usuário, sejam atualizados com a sesssão,
       * pois quem será enviado são os dados do formulário.
       * dessa forma, mesmo que os dados do usuário não sejam alterados, eles estarão conforme
       * os dados da sessão.
       */
      // const dadosCheckin = JSON.parse(sessionStorage.getItem('dadosCheckin'));
      const dadosCheckin = JSON.parse(Cookies.get('dadosCheckin'));

      // chamar o método que atualiza os dados do cliente logado
      atualizarDadosClienteLogado(userData);

      // atualizar informações usuário
      if(userData.user && perfilUsuario == 'BAR CLIENTE'){
        // aqui o usuário está logado como cliente
        setInformacoesUsuario({
          nome: userData.user.name,
          email: userData.user.email,
          numeroMesa: dadosCheckin.numeroMesa,
          numeroComanda: dadosCheckin.numeroComanda,
          numeroCpf: userData.dadosCliente.cpf,
          numeroTelefone: userData.dadosCliente.telefone_celular,
        });
      }else if(dadosCheckin) {
        setInformacoesUsuario({
          nome: dadosCheckin.nome,
          email: dadosCheckin.email,
          numeroMesa: dadosCheckin.numeroMesa,
          numeroComanda: dadosCheckin.numeroComanda,
          numeroCpf: dadosCheckin.numeroCpf,
          numeroTelefone: dadosCheckin.numeroTelefone,
        });
      }

      const buscarProdutos = async () => {
          try {
              // buscar todos os produtos do estabelecimento
              await fetchProdutosEstabelecimento();
              setCarregando(false);
          } catch (error) {
            setCarregando(false);
              console.error('Erro ao buscar os produtos:', error);
          }
      };

      buscarProdutos();

  }, []);

  if (carregando) {
    return <Carregando />;
  }


  const handleInputChange = (e) => {

    console.log('***entrou em handleInputChange***');

    const { name, value } = e.target;
    setInformacoesUsuario({ ...informacoesUsuario, [name]: value });
  
    // Atualiza o dadosCheckin
    const dadosCheckinAtualizado = { ...dadosCheckin };
    if (name === 'nome') dadosCheckinAtualizado.nome = value;
    if (name === 'email') dadosCheckinAtualizado.email = value;
    if (name === 'numeroMesa') dadosCheckinAtualizado.numeroMesa = value;
    if (name === 'numeroComanda') dadosCheckinAtualizado.numeroComanda = value;
    if (name === 'numeroCpf') dadosCheckinAtualizado.numeroCpf = value;
    if (name === 'numeroTelefone') dadosCheckinAtualizado.numeroTelefone = value;
    sessionStorage.setItem('dadosCheckin', JSON.stringify(dadosCheckinAtualizado));


    // Armazena as variáveis nos cookies
    const date = new Date();
    date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000)); // 30 dias
    Cookies.set('dadosCheckin', JSON.stringify(dadosCheckinAtualizado), { expires: date });


    const teste = JSON.parse(Cookies.get('dadosCheckin'));
    console.log('teste:');
    console.log(teste);
  };

  const handleAdicionarPedido = (produto, quantidade) => {
    const pedidoExistente = pedidos.find((pedido) => pedido.produto.id === produto.id);
    const observacao = observacoes[produto.id] || '';
    if (pedidoExistente) {
      pedidoExistente.quantidade = quantidade;
      pedidoExistente.observacao = observacao;
      pedidoExistente.dadosCheckin = dadosCheckin;
    } else {
      pedidos.push({ 
        produto, quantidade, observacao: observacoes[produto.id], dadosCheckin: dadosCheckin
      });
    }
    setPedidos([...pedidos]);

    console.log('!! Pedido: !!');
    console.log(pedidos);
  };

  const handleObservacaoChange = (produto, observacao) => {
    const pedidoExistente = pedidos.find((pedido) => pedido.produto.id === produto.id);
    if (pedidoExistente) {
      pedidoExistente.observacao = observacao;
      pedidoExistente.dadosCheckin = dadosCheckin;
    } else {
      pedidos.push({ produto, observacao, dadosCheckin });
    }
    setPedidos([...pedidos]);

    console.log('!! Pedido: !!');
    console.log(pedidos);
  };

  // buscar todos os produtos do estabelecimento, para checkar os que já tem
  const fetchProdutosEstabelecimento = async () => {
      console.log('Entrou em fetchProdutosEstabelecimento em CardapioPage');
      try {
          const dados = await buscarProdutosEstabelecimentoParaCardapio(dadosCheckin);

          console.log('*** produtos estab ***', dados.produtosEstabelecimento);

          if (dados?.produtosEstabelecimento) {

              console.log('-> Produtos recebidos: ');
              console.log(dados.produtosEstabelecimento);

              // vamos setar os produtos do estabelecimento
              setProdutosEstabelecimento(dados.produtosEstabelecimento);
          }

      } catch (error) {
          console.error('Erro ao buscar produtos:', error);
      }
  };

  const handleSubmit = async (e) => {
    
    setCarregando(true);

    console.log('entrou no handleSubmit...');

    console.log('vamos guardar os dados do cliente, na sessão, em dadosCheckin');

    console.log('====dadosCheckin antes=====');
    console.log(dadosCheckin);
    console.log('====dadosCheckin=====');

    // vamos verificar se o usuário quer comprar fichas ou fazer pedido
    const modo = location.state?.modo;

    console.log('modo: ');
    console.log(modo);


    // vamos atualizar o dadosCheckin com os dados do cliente
    const dadosCheckinAtualizado = { 
      ...dadosCheckin, 
      nome: informacoesUsuario.nome, 
      email: informacoesUsuario.email,
      numeroMesa: informacoesUsuario.numeroMesa, 
      numeroComanda: informacoesUsuario.numeroComanda,
      numeroCpf: informacoesUsuario.numeroCpf,
      numeroTelefone: informacoesUsuario.numeroTelefone,
    };
    sessionStorage.setItem('dadosCheckin', JSON.stringify(dadosCheckinAtualizado));
    
    
    
    console.log('====dadosCheckin depois=====');
    console.log(dadosCheckin);
    console.log('====dadosCheckin=====');

    e.preventDefault();

    if (pedidos.length === 0) {
      alert('Você não adicionou nenhum produto ao pedido!');
      return;
    }

    try {

      if(modo == 'pedido'){

        // aqui é pedido
        const response = await cadastrarPedido({
          pedidos,
          informacoesUsuario,
        });
        console.log('Pedido feito com sucesso:', response);
        alert('Pedido feito com sucesso!');

        setCarregando(false);

        navigate('/meus-pedidos-em-andamento');

      } else if (modo == 'comprar-fichas') {
        // aqui é comprar fichas

        const response = await comprarFichas({
          pedidos,
          informacoesUsuario,
        });
        console.log('Fichas solicitadas com sucesso:', response);
        alert('Fichas solicitadas com sucesso!');

        setCarregando(false);

        navigate('/minhas-fichas');

      }



      
    } catch (error) {

      setCarregando(false);

      // if (error.response.status === 422) {
      //   alert('CPF inválido!!!');
      // } 
      
      console.error('Erro ao fazer o pedido:', error);
      const errorMessage =
        error.response?.data?.message || 'Erro ao fazer o pedido. Tente novamente.';
      alert(errorMessage);
    }
  };


  // separar os produtos por categoria
  const produtosPorCategoria = produtosEstabelecimento.reduce((acc, produto) => {
    const nomeCategoria = produto.nome_categoria_produto;
    if (!acc[nomeCategoria]) {
      acc[nomeCategoria] = [];
    }
    acc[nomeCategoria].push(produto);
    return acc;
  }, {});
  
  

  return (
    <div className="mostrar-dados-container">
      <TituloComponent />

      <form onSubmit={handleSubmit}>


        <div className="content">

          
          <h1 className="sub-titulo">{modo === 'pedido' ? 'Fazer Pedido' : 'Solicitar Fichas'}</h1>

          <div className="box-dados">           

            <div className="form-group">
              <label htmlFor="nome">Nome:</label>
              <input
                type="text"
                id="nome"
                value={informacoesUsuario.nome || dadosCheckin.nome}
                onChange={handleInputChange}
                name="nome"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email:</label>
              <input
                type="email"
                id="email"
                value={informacoesUsuario.email || dadosCheckin.email}
                onChange={handleInputChange}
                name="email"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="numeroCpf">CPF:</label>
              <input
                type="cpf"
                id="numeroCpf"
                value={informacoesUsuario.numeroCpf || dadosCheckin.numeroCpf}
                onChange={handleInputChange}
                name="numeroCpf"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="numeroTelefone">Telefone com DDD:</label>
              <input
                type="string"
                id="numeroTelefone"
                value={informacoesUsuario.numeroTelefone || dadosCheckin.numeroTelefone}
                onChange={handleInputChange}
                name="numeroTelefone"
                required
              />
            </div>
          </div>

          <div className="box-dados">           
            <div className="form-group">
              <label htmlFor="numeroMesa">Número da Mesa:</label>
              <input
                type="number"
                id="numeroMesa"
                value={informacoesUsuario.numeroMesa || dadosCheckin.numeroMesa}
                onChange={handleInputChange}
                name="numeroMesa"
                // required
              />
            </div>

            <div className="form-group">
              <label htmlFor="numeroComanda">Número da Comanda:</label>
              <input
                type="number"
                id="numeroComanda"
                value={informacoesUsuario.numeroComanda || dadosCheckin.numeroComanda}
                onChange={handleInputChange}
                name="numeroComanda"
              />
            </div>

            <div className="form-group">
              <label >Atenção!!!</label>
              <label >Para melhor controle, utilizados cookies.</label>
            </div>

          </div>


          {
          // se o usuário estiver logado, mostraremos o cartão que será utilizado
          userData.statusUsuario == 'logado' && perfilUsuario == 'BAR CLIENTE'
          ?
            <div className="box-dados">           
              <div className="form-group">
                <label htmlFor="numeroMesa">Cartão salvo:</label>
                <label htmlFor="numeroMesa">Final {getFinalCartaoUsuarioLogado(userData)} </label>
              </div>
            </div>
          :
            <label htmlFor="numeroMesa">Você não possui cartão salvo</label>
          }


          <p className="sub-titulo-cardapio">Cardápio {dadosCheckin.estabelecimento.nome}!</p>
          

          {/* Vamos mostrar os produtos separados por categoria */}
          {Object.entries(produtosPorCategoria).map(([nomeCategoria, produtos]) => (
            <div key={nomeCategoria}>

              <div 
                className="box-categoria"
                style={{ cursor: 'pointer' }}
                onClick={() => toggleCategoria(nomeCategoria)}
              >
                <h1 className="sub-titulo" >
                  {nomeCategoria}
                </h1>
              </div>

              {categoriaAberta === nomeCategoria && (
                produtos.map((produto, index) => (
                  
                  <div key={index} className="box-dados container-fluid">
                    <div className="row">
                      <div className="col-md-4">
                        {produto?.caminhoImagemProduto ? (
                          <img className='img-cardapio'
                            src={BASE_URL + produto.caminhoImagemProduto} alt={produto.nome} 
                          />
                        ) : (
                          'Imagem não disponível'
                        )}
                      </div>
                      <div className="col-md-8">
                        <p className='nome-produto-cardapio' >{produto.nome}</p>
                        <p className='preco-produto-cardapio' >R$ {produto.preco_venda}</p>
                      </div>

                      <div className="form-group">
                        <label htmlFor="nomeCompleto">Quantidade:</label>
                        <select onChange={(e) => handleAdicionarPedido(produto, parseInt(e.target.value))}>
                          <option value="">Selecione a quantidade</option>
                          {[0, 1, 2, 3, 4, 5].map(qtd => (
                            <option key={qtd} value={qtd}>{qtd}</option>
                          ))}
                        </select>
                      </div>

                      <div className="form-group">
                        <label htmlFor="observacao">Observação:</label>
                        <input
                          type="text"
                          id="observacao"
                          value={observacoes[produto.id] || ''}
                          onChange={(e) => {
                            setObservacoes({ ...observacoes, [produto.id]: e.target.value });
                            handleObservacaoChange(produto, e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                ))
              )}



            </div>
          ))}


          {/* <button type="submit" className="btn-primary">
              Enviar Pedido
          </button> */}

          <button type="submit" className="btn-primary">
            {modo === 'pedido' ? 'Enviar Pedido' : 'Solicitar Fichas'}
          </button>
          
        </div>

      </form>
    </div>
  );
};

export default CardapioPage;